import { render } from "./OrganizationsPage.vue?vue&type=template&id=390798fc&scoped=true"
import script from "./OrganizationsPage.vue?vue&type=script&lang=js"
export * from "./OrganizationsPage.vue?vue&type=script&lang=js"

import "./OrganizationsPage.vue?vue&type=style&index=0&id=390798fc&scoped=true&lang=css"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390798fc"]])

export default __exports__